import { styled } from '@mui/material/styles';
import { IconButton, Box } from '@mui/material';

export const ImageModalOverlay = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: 0,
}));

export const ImageModalContainer = styled(Box)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  maxWidth: '90vw',
  maxHeight: '90vh',
  width: 'auto',
  height: 'auto',
}));

export const ImageModalHeader = styled(Box)(({ theme }) => ({
  position: 'absolute',
  top: 0,
  right: 0,
  zIndex: 1,
  padding: theme.spacing(1),
}));

export const ImageModalCloseButton = styled(IconButton)(({ theme }) => ({
  backgroundColor: 'rgba(0, 0, 0, 0.5)',
  color: 'white',
  '&:hover': {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
  },
  '& .MuiSvgIcon-root': {
    fontSize: '2rem',
  },
}));

export const ImageModalContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: '100%',
  minHeight: 0,
}));

export const ExpandedImage = styled('img')(({ theme }) => ({
  maxWidth: '100%',
  maxHeight: '90vh',
  width: 'auto',
  height: 'auto',
  objectFit: 'contain',
  borderRadius: theme.spacing(1),
  boxShadow: '0 8px 32px rgba(0, 0, 0, 0.3)',
  cursor: 'default',
}));
